<!-- Container -->
<div class="container">

  <mat-stepper #stepper class="help-stepper" orientation="vertical" [linear]="false">

    <mat-step [stepControl]="fromProblemDevice">
      <form [formGroup]="fromProblemDevice">
        <ng-template matStepLabel>Are you submitting this help request on the device you're experiencing the problem with?</ng-template>
        <br>
        <mat-radio-group formControlName="fromProblemDevice">
          <mat-radio-button value="Yes">Yes</mat-radio-button>
          <mat-radio-button value="No" style="padding-left: 25px;">No</mat-radio-button>
        </mat-radio-group>
        <div>

          <!-- Go to next help form step -->
          <button mat-flat-button
                  matStepperNext
                  class="text-button"
                  type="button"
                  style="margin-top: 25px;">
            Next
          </button>
        </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="problemAreas">
    <form [formGroup]="problemAreas">
      <ng-template matStepLabel>What are you having trouble with? (Select all that apply)</ng-template>
      <mat-selection-list #list formControlName="problemAreas">
        <mat-list-option checkboxPosition="before" value="Account">Account</mat-list-option>
        <mat-list-option checkboxPosition="before" value="Adding Gear Types">Adding Gear Types</mat-list-option>
        <mat-list-option checkboxPosition="before" value="Submitting">Submitting</mat-list-option>
        <mat-list-option checkboxPosition="before" value="Other, please specify">Other, specify below</mat-list-option>
      </mat-selection-list>

      <!-- Go back or continue from help form selection boxes -->
      <div style="display:flex; justify-content: space-between; margin-top: 10px;">
        <button mat-flat-button
                matStepperPrevious
                class="text-blue-button"
                type="button">
          Back
        </button>
        <button mat-flat-button
                matStepperNext
                type="button"
                class="text-button">
          Next
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="comment">
    <form [formGroup]="comment">
      <ng-template matStepLabel>Any additional comments?</ng-template>
      <div class="row">
        <mat-form-field appearance="fill">
          <mat-label>Comments</mat-label>
          <textarea matInput rows="10" formControlName="comment"></textarea>
        </mat-form-field>
      </div>

      <!-- Go back or submit help form -->
      <div style="display:flex; justify-content: space-between; margin-top: 10px;">
        <button mat-flat-button
                matStepperPrevious
                class="text-blue-button"
                type="button">
          Back
        </button>
        <button mat-flat-button
                [disabled]="sending"
                class="text-button"
                type="submit"
                (click)="submitHelpForm()">
          Submit
        </button>
      </div>
    </form>
    </mat-step>

  </mat-stepper>

</div>
